import { configContext } from '../managers/config'

export default configContext.Provider
